import React from 'react';
import { Grid, Checkbox, FormControlLabel } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import SettingsEthernetIcon from '@mui/icons-material/SettingsEthernet';
import { Autocomplete, Button, Card } from '@totalsoft/rocket-ui';
import { useTranslation } from 'react-i18next';
import { emptyArray } from 'constants/defaultValues';
import { requestTypes } from '../constants';
import { get, set, sequence } from '@totalsoft/change-tracking-react';
import PropTypes from 'prop-types';
import { onCheckBoxChange } from 'utils/propertyChangeAdapters';

const ServiceLogsFiltersComponent = ({ filtersLens, onRequestTypeChange, onRetrieveInsuranceServiceLogs, disabled }) => {
  const { t } = useTranslation();

  return (
    <Card id='ServiceLogsComponent_IconCard' icon={SettingsEthernetIcon} title={t('Offer.Edit.InsuranceServiceLogs.Title')}>
      <Grid container spacing={1}>
        <Grid item xs={6} md={4}>
          <Autocomplete
            id='filterServiceLogs_queryType'
            options={requestTypes || emptyArray}
            valueKey={'code'}
            labelKey={'name'}
            onChange={onRequestTypeChange}
            label={t('Offer.Edit.InsuranceServiceLogs.RequestType')}
            value={filtersLens.requestType |> get}
            isSearchable={true}
            isClearable={true}
            simpleValue={true}
            disabled={disabled.filters}
          />
        </Grid>
        <Grid container px={2} pt={1}>
          {filtersLens?.insurersData && (filtersLens?.insurersData |> sequence).length > 0
            ? (filtersLens?.insurersData |> sequence).map((insurer, index) => {
                const { insurerId, insurerName, period } = insurer |> get;
                return (
                  insurerId && (
                    <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={insurer.selected |> get}
                            id={'ServiceLogsComponent_Insurer_' + index}
                            disabled={disabled.filters}
                            onChange={insurer.selected |> set |> onCheckBoxChange}
                          />
                        }
                        label={t('Offer.Edit.InsuranceServiceLogs.InsurerAndPeriod', {
                          insurerName,
                          period
                        })}
                      />
                    </Grid>
                  )
                );
              })
            : (filtersLens.requestType |> get) !== null && (
                <Grid container alignItems={'center'}>
                  <InfoIcon />
                  <span> {t('Offer.Edit.InsuranceServiceLogs.NoInsurers')}</span>
                </Grid>
              )}
        </Grid>
        <Grid item xs={12}>
          <Button
            id='ServiceLogsComponent_ViewRequestButton'
            color='primary'
            onClick={onRetrieveInsuranceServiceLogs}
            disabled={disabled.action}
            right={true}
          >
            {t('Offer.Edit.InsuranceServiceLogs.ViewRequests')}
          </Button>
        </Grid>
      </Grid>
    </Card>
  );
};

ServiceLogsFiltersComponent.propTypes = {
  filtersLens: PropTypes.object.isRequired,
  onRequestTypeChange: PropTypes.func,
  onRetrieveInsuranceServiceLogs: PropTypes.func,
  disabled: PropTypes.object
};

export default ServiceLogsFiltersComponent;
